
export interface GooglePlaceTextSearchResponse {
  candidates: {
    formatted_address?: string,
    name?: string,
  }[],
  status: 'OK' | 'ZERO_RESULTS' | 'INVALID_REQUEST' | 'OVER_QUERY_LIMIT' | 'REQUEST_DENIED' | 'UNKNOWN_ERROR',
  error_message?: string,
  info_messages?: string[],
}

export interface PlacesSearchResult {
  predictions: PlacesItem[]
  status: 'OK' | 'ZERO_RESULTS' | 'INVALID_REQUEST' | 'OVER_QUERY_LIMIT' | 'REQUEST_DENIED' | 'UNKNOWN_ERROR',
}

export interface PlacesItem {
  description: string;
  place_id: string;
  reference?: string | null;
  matched_substrings?: [
    {
      length?: number;
      offset?: number | null;
    }
  ];
  terms?: [
    {
      offset?: number | null;
      value?: string | null;
    }
  ];
  types?: string[];
  structured_formatting: {
    main_text: string;
    main_text_matched_substrings: [
      {
        length?: number | null;
        offset?: number | null;
      },
      secondary_text: string
    ];
  };
}

export interface PlaceDetailsResult {
  result: {
    formatted_address: string;
    name: string;
  };
  status: 'OK' | 'ZERO_RESULTS' | 'INVALID_REQUEST' | 'OVER_QUERY_LIMIT' | 'REQUEST_DENIED' | 'UNKNOWN_ERROR',
}
